import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=82e5aa18&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/all.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/simple_crud.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Default.vue?vue&type=style&index=2&id=82e5aa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e5aa18",
  null
  
)

export default component.exports